import { render } from "./Ttg.vue?vue&type=template&id=590c9982"
import script from "./Ttg.vue?vue&type=script&lang=js"
export * from "./Ttg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__